var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "content" }, [
    _c("div", { staticClass: "card-deck p-md-5" }, [
      _vm.hasAnyRole("ROLE_ADMIN", "ROLE_YUKYU_READ", "ROLE_YUKYU_ADMIN")
        ? _c("div", { staticClass: "card m-1" }, [
            _c(
              "div",
              {
                staticClass: "card-header p-3",
                staticStyle: { position: "relative" }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _vm.hasAnyRole("ROLE_ADMIN", "ROLE_YUKYU_ADMIN")
                  ? _c(
                      "div",
                      {
                        staticClass: "btn-group",
                        staticStyle: { padding: "10px 0 0" }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm m-1",
                            attrs: {
                              id: "yukyuBulkApproval",
                              disabled: "disabled"
                            },
                            on: {
                              click: function($event) {
                                return _vm.yukyuBulkConfirm()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      一括承認\n                  "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("modal", {
                          ref: "yukyuBulkModal",
                          on: {
                            ok: function($event) {
                              return _vm.yukyuBulkStatusUpdate("confirm")
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "absolute",
                      bottom: "0px",
                      right: "10px"
                    }
                  },
                  [_vm._v("未承認(" + _vm._s(_vm.yukyuList.length) + ")")]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-block p-1" }, [
              _vm.yukyuList.length == 0
                ? _c("div", [_vm._v("未承認のレコードはありません")])
                : _c("div", [
                    _c(
                      "table",
                      { staticClass: "table table-bordered table-responsive" },
                      [
                        _c("thead", { staticClass: "thead-light" }, [
                          _c("tr", [
                            _vm.hasAnyRole("ROLE_ADMIN", "ROLE_YUKYU_ADMIN")
                              ? _c("th", [
                                  _c(
                                    "div",
                                    { staticClass: "checkbox noflap" },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          attrs: {
                                            type: "checkbox",
                                            id: "yukyuAllCheck"
                                          },
                                          on: { click: _vm.yukyuCheckAll }
                                        }),
                                        _vm._v(" "),
                                        _vm._m(1)
                                      ])
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("th", [_vm._v("氏名")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("対象日")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("種類")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("ステータス")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("承認/取消")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("申請日")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          _vm._l(_vm.yukyuList, function(result, index) {
                            return _c("tr", { key: index }, [
                              _vm.hasAnyRole("ROLE_ADMIN", "ROLE_YUKYU_ADMIN")
                                ? _c("td", [
                                    _c(
                                      "div",
                                      { staticClass: "checkbox noflap" },
                                      [
                                        _c("label", [
                                          _c("input", {
                                            staticClass: "yukyuCheck",
                                            attrs: {
                                              type: "checkbox",
                                              name: "idList"
                                            },
                                            domProps: {
                                              value:
                                                result.userId +
                                                "," +
                                                result.targetDate
                                            },
                                            on: { click: _vm.yukyuCheckSingle }
                                          }),
                                          _vm._v(" "),
                                          _vm._m(2, true)
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(result.userName))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(result.targetDate))]),
                              _vm._v(" "),
                              _c("td", [
                                result.requestType == 1
                                  ? _c("span", [_vm._v("有給")])
                                  : result.requestType == 2
                                  ? _c("span", [
                                      _vm._v(
                                        "特別休暇（" +
                                          _vm._s(result.specialLeaveName) +
                                          "）"
                                      )
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(result.status))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm.hasAnyRole("ROLE_ADMIN", "ROLE_YUKYU_ADMIN")
                                  ? _c("div", [
                                      result.status === "申請中" ||
                                      result.status === "差し戻し"
                                        ? _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.updateYukyuStatus(
                                                      "confirm",
                                                      result.userId,
                                                      result.targetDate
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("承認")]
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      result.status === "承認済み"
                                        ? _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.updateYukyuStatus(
                                                      "remand",
                                                      result.userId,
                                                      result.targetDate
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("差し戻し")]
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", [
                                _vm._v(_vm._s(_vm._f("date")(result.createdAt)))
                              ])
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ])
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _vm.hasAnyRole("ROLE_ADMIN", "ROLE_KOTSUHI_READ", "ROLE_KOTSUHI_ADMIN")
        ? _c("div", { staticClass: "card m-1" }, [
            _c(
              "div",
              {
                staticClass: "card-header p-3",
                staticStyle: { position: "relative" }
              },
              [
                _vm._m(3),
                _vm._v(" "),
                _vm.hasAnyRole("ROLE_ADMIN", "ROLE_KOTSUHI_ADMIN")
                  ? _c(
                      "div",
                      {
                        staticClass: "btn-group",
                        staticStyle: { padding: "10px 0 0" }
                      },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary btn-sm m-1",
                            attrs: {
                              id: "kotsuhiBulkApproval",
                              disabled: "disabled"
                            },
                            on: {
                              click: function($event) {
                                return _vm.kotsuhiBulkConfirm()
                              }
                            }
                          },
                          [
                            _vm._v(
                              "\n                      一括承認\n                  "
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c("modal", {
                          ref: "kotsuhiBulkConfirm",
                          on: {
                            ok: function($event) {
                              return _vm.kotsuhiBulkStatusUpdate("confirm")
                            }
                          }
                        })
                      ],
                      1
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticStyle: {
                      position: "absolute",
                      bottom: "0px",
                      right: "10px"
                    }
                  },
                  [_vm._v("未承認(" + _vm._s(_vm.kotsuhiList.length) + ")")]
                )
              ]
            ),
            _vm._v(" "),
            _c("div", { staticClass: "card-block p-1" }, [
              _vm.kotsuhiList.length == 0
                ? _c("div", [_vm._v("未承認のレコードはありません")])
                : _c("div", [
                    _c(
                      "table",
                      { staticClass: "table table-bordered table-responsive" },
                      [
                        _c("thead", { staticClass: "thead-light" }, [
                          _c("tr", [
                            _vm.hasAnyRole("ROLE_ADMIN", "ROLE_KOTSUHI_ADMIN")
                              ? _c("th", [
                                  _c(
                                    "div",
                                    { staticClass: "checkbox noflap" },
                                    [
                                      _c("label", [
                                        _c("input", {
                                          attrs: {
                                            type: "checkbox",
                                            id: "kotsuhiAllCheck"
                                          },
                                          on: { click: _vm.kotsuhiCheckAll }
                                        }),
                                        _vm._v(" "),
                                        _vm._m(4)
                                      ])
                                    ]
                                  )
                                ])
                              : _vm._e(),
                            _vm._v(" "),
                            _c("th", [_vm._v("氏名")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("対象日")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("費用")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("ステータス")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("承認/取消")]),
                            _vm._v(" "),
                            _c("th", [_vm._v("申請日")])
                          ])
                        ]),
                        _vm._v(" "),
                        _c(
                          "tbody",
                          { attrs: { "th:remove": "all-but-first" } },
                          _vm._l(_vm.kotsuhiList, function(result, index) {
                            return _c("tr", { key: index }, [
                              _vm.hasAnyRole("ROLE_ADMIN", "ROLE_KOTSUHI_ADMIN")
                                ? _c("td", [
                                    _c(
                                      "div",
                                      { staticClass: "checkbox noflap" },
                                      [
                                        _c("label", [
                                          _c("input", {
                                            staticClass: "kotsuhiCheck",
                                            attrs: {
                                              type: "checkbox",
                                              name: "idList"
                                            },
                                            domProps: { value: result.id },
                                            on: {
                                              click: _vm.kotsuhiCheckSingle
                                            }
                                          }),
                                          _vm._v(" "),
                                          _vm._m(5, true)
                                        ])
                                      ]
                                    )
                                  ])
                                : _vm._e(),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(result.userName))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(result.targetDate))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(result.expense))]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(result.status))]),
                              _vm._v(" "),
                              _c("td", [
                                _vm.hasAnyRole(
                                  "ROLE_ADMIN",
                                  "ROLE_KOTSUHI_ADMIN"
                                )
                                  ? _c("div", [
                                      result.status === "申請中" ||
                                      result.status === "差し戻し"
                                        ? _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass:
                                                  "btn btn-primary btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.updateKotsuhiStatus(
                                                      "confirm",
                                                      result.id
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("承認")]
                                            )
                                          ])
                                        : _vm._e(),
                                      _vm._v(" "),
                                      result.status === "承認済み"
                                        ? _c("div", [
                                            _c(
                                              "button",
                                              {
                                                staticClass: "btn btn-sm",
                                                attrs: { type: "button" },
                                                on: {
                                                  click: function($event) {
                                                    return _vm.updateKotsuhiStatus(
                                                      "remand",
                                                      result.id
                                                    )
                                                  }
                                                }
                                              },
                                              [_vm._v("差し戻し")]
                                            )
                                          ])
                                        : _vm._e()
                                    ])
                                  : _vm._e()
                              ]),
                              _vm._v(" "),
                              _c("td", [_vm._v(_vm._s(result.createdDate))])
                            ])
                          }),
                          0
                        )
                      ]
                    )
                  ])
            ])
          ])
        : _vm._e()
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticStyle: { display: "table" },
        attrs: { href: "/admin/leave-request/top" }
      },
      [
        _c("i", { staticClass: "far fa-thumbs-up fa-5x" }),
        _vm._v("休暇申請管理\n              ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-material" }, [
      _c("span", { staticClass: "check" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-material" }, [
      _c("span", { staticClass: "check" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c(
      "a",
      {
        staticStyle: { display: "table" },
        attrs: { href: "/admin/kotsuhi/top" }
      },
      [
        _c("i", { staticClass: "fa fa-train fa-5x" }),
        _vm._v("交通費管理\n              ")
      ]
    )
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-material" }, [
      _c("span", { staticClass: "check" })
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "checkbox-material" }, [
      _c("span", { staticClass: "check" })
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-26219508", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-26219508","hasScoped":true,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/assets/js/components/admin/AdminTop.vue
// module id = 385
// module chunks = 0